// extracted by mini-css-extract-plugin
export default {"bottom":"bottom__SSWPX"};